import { Component, DestroyRef, inject, Injector, OnDestroy } from '@angular/core';
import { FieldArrayType, FieldType, FormlyFieldConfig } from '@ngx-formly/core';
import { RepeaterService } from '../../service/repeater-service/repeater.service';
import { Subject, take } from 'rxjs';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { v4 as uuidv4 } from 'uuid';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { FormControl } from '@angular/forms';
import { BulkUpdateSection } from '../../ui/Art57Section/BulkUpdateSection';

@Component({
  selector: 'app-bulk-update-action-type',
  templateUrl: './bulk-update-action-type.component.html',
  styleUrl: './bulk-update-action-type.component.scss'
})
export class BulkUpdateActionTypeComponent extends FieldType<FormlyFieldConfig>
  implements OnDestroy {
    private destroy$ = new Subject<void>();

  constructor(
      private injector: Injector,
      private repeaterService: RepeaterService
    ) {
      super();
    }

  ngOnInit() {
    this.repeaterService.registerAdd(this.myAdd.bind(this));
    this.repeaterService.registerRemove(this.myRemove.bind(this));
  }

    ngOnDestroy(): void {
    this.repeaterService.unregisterAdd(this.myAdd.bind(this));
    this.repeaterService.unregisterRemove(this.myRemove.bind(this));
    this.destroy$.next();
    this.destroy$.complete();
  }

  myAdd() {
    const repeaterId = this.field.parent!.parent!.props!['repeaterId'];
    const repeater = this.injector.get(RepeaterService).getRepeater(repeaterId);
    if (repeater) {
      repeater.add();
    }
    
  }


  myRemove() {
  const removeComponentIds = this.injector.get(Art57Section).bulkupdate.actionsCheckedRepeater;
  if(removeComponentIds.length == 0) {
    return;
  }
    const repeaterId = this.field.parent!.parent!.props!['repeaterId'];
    const repeater = this.injector.get(RepeaterService).getRepeater(repeaterId);

    const filterDataModel = this.field?.parent?.parent?.model;
    removeComponentIds.forEach(currentComponentId => {
      const index = filterDataModel?.findIndex(
        (item: any) => item.componentID === currentComponentId,
      );

      if (repeater && index !== undefined && index > -1) {
      repeater.remove(index);
      this.injector.get(Art57Section).bulkupdate.actionsCheckedRepeater.filter(item => item !== currentComponentId)
    }
  });
    

    

    if (this.repeaterLength() == 0) {
        this.injector.get(Art57Section).bulkupdate.criteriaModel.actionset = { action: [{ componentID: 'pending_init' }] };
        this.options.build?.();      
    }
  }

  mustDisableRemove() {
    return (this.repeaterLength() == 1 && this.field.model.condition.length == 0 && this.field.model.operation.length == 0);
  }
  getComponentId(){
    return this.formControl.parent?.get('componentID')?.value;
  }

  repeaterLength(): number {
      const repeaterId = this.field.parent!.parent!.props!['repeaterId'];
      const repeater = this.injector.get(RepeaterService).getRepeater(repeaterId);
      return repeater.field.fieldGroup.length;
    }

    returnModel(): string {
      return JSON.stringify(this.field.model);
    }

getIndexByModel(): number {
    const currentComponentId =
      this.formControl.parent?.get('componentID')?.value;

    const filterDataModel = this.field?.parent?.parent?.model;
    const index = filterDataModel?.findIndex(
      (item: any) => item.componentID === currentComponentId,
    );
  return index;
}    

getActionSetTitle(): string {
  return this.injector.get(Art57Section).bulkupdate.actionSetFilename;
}
}
